module.exports = __webpack_public_path__ + "static/media/litho_2.3e9719c0.jpg";